import { constructDOM, makeVisibleAfterFullLoad } from './markup';
import { displayWeatherData } from '../../../shared/javascripts/weather-data.js';
import { loadmaps } from './maps';
import { getLatLon, browserGeolocator } from '../../../shared/javascripts/geocode';
import { getInitialLocation } from '../../../shared/javascripts/default-location';
import { recenterMap } from '../../../shared/javascripts/interactive_map/layers-init';
import { displayInteractiveMap } from '../../../shared/javascripts/interactive_map';
import { determineNavbarUrls } from '../../../shared/javascripts/components/navbar';
import { setMobileMenuActions } from '../../../shared/javascripts/components/menu';
import { lightBoxPlugin } from '../../../shared/javascripts/components/lity'
import { addSVGCustomIcons } from '../../../shared/javascripts/icons';


const startApp = () => {

  const userDefaultLocation = localStorage.getItem('userDefaultLocation');

  if (!userDefaultLocation) {
    // Plot Initial Location - on first page load
    const defaultLocation = getInitialLocation().defaultLocation;
    const defaultLat = getInitialLocation().defaultLat;
    const defaultLon = getInitialLocation().defaultLon;
    
    addSVGCustomIcons();
    constructDOM();
    determineNavbarUrls();
    setMobileMenuActions();
    lightBoxPlugin();
    displayInteractiveMap(defaultLat, defaultLon);
    displayWeatherData(defaultLat, defaultLon, defaultLocation)
    loadmaps();
    enableCustomLocation();
    enableBrowserGeolocation();
    makeVisibleAfterFullLoad();
  } else {
    
    // Plot weather for last saved location
    const savedLocation = JSON.parse(localStorage.getItem('userDefaultLocation'));
    const { lat, lon, _, cityStateZip } = savedLocation;
    
    const city = cityStateZip[0];
    const state = cityStateZip[1];
    const location = `${city}, ${state}`;
    
    addSVGCustomIcons();
    constructDOM();
    determineNavbarUrls();
    setMobileMenuActions();
    lightBoxPlugin();
    loadmaps();
    displayInteractiveMap();
    enableCustomLocation();
    enableBrowserGeolocation();
    displayWeatherData(lat, lon, location);
    makeVisibleAfterFullLoad();
  }
};


// Wait for user to enter a custom location
const enableCustomLocation = () => {
  document.getElementById('form-get-weather').addEventListener('submit', (evt) => {
    evt.preventDefault();
  
    const inputLocation = document.getElementById('input-location').value;
    document.getElementById('form-get-weather').reset();
  
    getLatLon(inputLocation).then(data => {
      const lat = data.lat;
      const lon = data.lon;
      const address = data.address;
      const cityStateZip = data.cityStateZip;
      const stationId = data.stationId;
      
      const city = data.cityStateZip[0];
      const state = data.cityStateZip[1];
      const location = `${city}, ${state}`;
  
      displayWeatherData(lat, lon, location)
      recenterMap(lat, lon)
      
      // Store location as default
      localStorage.setItem('userDefaultLocation', JSON.stringify({ lat, lon, address, cityStateZip, stationId }));
    })
    .catch(_ => document.getElementById('user-location-mainapp').innerHTML = 'Cannot find a location');
  });
};


// "Geolocator Icon" - user clicks it and weather data is returned
// Useful when the user changes location and then wants to go back to looking at weather for his/her location
const enableBrowserGeolocation = () => {
  document.getElementById('find-me').addEventListener('click', () => {
    browserGeolocator();
  });
};

export { startApp };